import { component } from 'picoapp'

class ContentAccordion {
  constructor(node, ctx) {
    // bindings
    this.onAccordionBtnClick = this.onAccordionBtnClick.bind(this)
    // this.collapseSiblings = this.collapseSiblings.bind(this)

    // selectors
    this._node = node;

    // privates
    this._ctx = ctx
    this._accordion_btns_arr = Array.from(this._node.getElementsByClassName('accordion-btn'))

    // events
    this._accordion_btns_arr.forEach((el) => el.addEventListener('click', this.onAccordionBtnClick))

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Handle accordion button click.
  //
  onAccordionBtnClick(e) {
    let element = e.currentTarget.parentElement,
        wrapper = element.getElementsByClassName('accordion-wrapper')[0],
        inner = wrapper.getElementsByClassName('accordion-inner')[0],
        heights = ['0px', `${inner.getBoundingClientRect().height}px`, 'auto']

    if (element.classList.contains('in-motion')) {
      return false
    }

    element.classList.add('in-motion')

    if (element.classList.contains('expanded')) {
      wrapper.classList.add('no-trans')
      wrapper.style.height = heights[1]
      wrapper.offsetHeight
      wrapper.classList.remove('no-trans')
      wrapper.style.height = heights[0]
      element.classList.remove('expanded')
    } else {
      // if (this._node.classList.contains('ingredients-accordion')) {
      //   this.collapseSiblings(element)
      // }

      element.classList.add('expanded')
      wrapper.classList.add('no-trans')
      wrapper.style.height = heights[0]
      wrapper.offsetHeight
      wrapper.classList.remove('no-trans')
      wrapper.style.height = heights[1]
    }

    wrapper.addEventListener('transitionend', callback)

    function callback(e) {
      wrapper.removeEventListener('transitionend', callback)

      if (element.classList.contains('expanded')) {
        wrapper.style.height = heights[2]
      }

      window.dispatchEvent(new Event('resize'))
      element.classList.remove('in-motion')
    }
  }

  //
  // Collapse siblings.
  //
  // collapseSiblings(element) {
  //   let btns = Array.from(element.parentNode.children),
  //       expanded_items = []
  //
  //   btns.forEach((el, index) => {
  //     if (element !== el && el.classList.contains('expanded')) {
  //       expanded_items.push(el)
  //     }
  //   })
  //
  //   expanded_items.forEach((el, index) => {
  //     let btn = el.querySelector('.accordion-btn')
  //     btn.dispatchEvent(new Event('click'))
  //   })
  // }
  // collapseSiblings(element) {
  //   let btns = Array.from(element.parentNode.children),
  //       expanded_items = []
  //
  //   btns.forEach((el, index) => {
  //     if (element !== el && el.classList.contains('expanded')) {
  //       expanded_items.push(el)
  //     }
  //   })
  //
  //   expanded_items.forEach((el, index) => {
  //     let btn = el.querySelector('.accordion-btn')
  //     btn.dispatchEvent(new Event('click'))
  //   })
  // }

  //
  // Handle unmount.
  //
  unmount() {
    this._accordion_btns_arr.forEach((el) => el.removeEventListener('click', this.onAccordionBtnClick))
  }
}

export default component((node, ctx) => new ContentAccordion(node, ctx))
